export default "__VITE_ASSET__BiZzgp9h__"